"use strict";

var _taggedTemplateLiteral = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schemaKeywords = void 0;

var applicability_1 = require("./applicability");

var dataType_1 = require("./dataType");

var defaults_1 = require("./defaults");

var keyword_1 = require("./keyword");

var util_1 = require("../util");

var _1 = require(".");

var codegen_1 = require("../codegen");

var names_1 = require("../names");

function schemaKeywords(it, types, typeErrors, errsCount) {
  var gen = it.gen,
      schema = it.schema,
      data = it.data,
      allErrors = it.allErrors,
      opts = it.opts,
      self = it.self;
  var RULES = self.RULES;

  if (schema.$ref && (opts.ignoreKeywordsWithRef || !util_1.schemaHasRulesButRef(schema, RULES))) {
    gen.block(function () {
      return keyword_1.keywordCode(it, "$ref", RULES.all.$ref.definition);
    }); // TODO typecast

    return;
  }

  if (!opts.jtd) checkStrictTypes(it, types);
  gen.block(function () {
    var _iterator = _createForOfIteratorHelper(RULES.rules),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var group = _step.value;
        groupKeywords(group);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    groupKeywords(RULES.post);
  });

  function groupKeywords(group) {
    if (!applicability_1.shouldUseGroup(schema, group)) return;

    if (group.type) {
      gen.if(dataType_1.checkDataType(group.type, data, opts.strict));
      iterateKeywords(it, group);

      if (types.length === 1 && types[0] === group.type && typeErrors) {
        gen.else();
        dataType_1.reportTypeError(it);
      }

      gen.endIf();
    } else {
      iterateKeywords(it, group);
    } // TODO make it "ok" call?


    if (!allErrors) gen.if(codegen_1._(_templateObject || (_templateObject = _taggedTemplateLiteral(["", " === ", ""])), names_1.default.errors, errsCount || 0));
  }
}

exports.schemaKeywords = schemaKeywords;

function iterateKeywords(it, group) {
  var gen = it.gen,
      schema = it.schema,
      useDefaults = it.opts.useDefaults;
  if (useDefaults) defaults_1.assignDefaults(it, group.type);
  gen.block(function () {
    var _iterator2 = _createForOfIteratorHelper(group.rules),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var rule = _step2.value;

        if (applicability_1.shouldUseRule(schema, rule)) {
          keyword_1.keywordCode(it, rule.keyword, rule.definition, group.type);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  });
}

function checkStrictTypes(it, types) {
  if (it.schemaEnv.meta || !it.opts.strictTypes) return;
  checkContextTypes(it, types);
  if (!it.opts.allowUnionTypes) checkMultipleTypes(it, types);
  checkKeywordTypes(it, it.dataTypes);
}

function checkContextTypes(it, types) {
  if (!types.length) return;

  if (!it.dataTypes.length) {
    it.dataTypes = types;
    return;
  }

  types.forEach(function (t) {
    if (!includesType(it.dataTypes, t)) {
      strictTypesError(it, "type \"".concat(t, "\" not allowed by context \"").concat(it.dataTypes.join(","), "\""));
    }
  });
  it.dataTypes = it.dataTypes.filter(function (t) {
    return includesType(types, t);
  });
}

function checkMultipleTypes(it, ts) {
  if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
    strictTypesError(it, "use allowUnionTypes to allow union type keyword");
  }
}

function checkKeywordTypes(it, ts) {
  var rules = it.self.RULES.all;

  for (var keyword in rules) {
    var rule = rules[keyword];

    if (typeof rule == "object" && applicability_1.shouldUseRule(it.schema, rule)) {
      var type = rule.definition.type;

      if (type.length && !type.some(function (t) {
        return hasApplicableType(ts, t);
      })) {
        strictTypesError(it, "missing type \"".concat(type.join(","), "\" for keyword \"").concat(keyword, "\""));
      }
    }
  }
}

function hasApplicableType(schTs, kwdT) {
  return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}

function includesType(ts, t) {
  return ts.includes(t) || t === "integer" && ts.includes("number");
}

function strictTypesError(it, msg) {
  var schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
  msg += " at \"".concat(schemaPath, "\" (strictTypes)");

  _1.checkStrictMode(it, msg, it.opts.strictTypes);
}